import Vue from "vue";
import App from "./App.vue";
import VuePageTransition from "vue-page-transition";
import router from "./router";
import store from "./store";
import axios from "axios";
import "bootstrap";
import "./sass/app.scss";

//axios.defaults.baseURL = "http://localhost:81";
axios.defaults.baseURL = "https://api.tocinn.com";

Vue.use(VuePageTransition);
Vue.config.productionTip = false;

new Vue({
    router,
    store,
    render: (h) => h(App),
}).$mount("#app");
